module.exports = __webpack_public_path__ + "static/media/file-download.af5b2dab.svg";